export default __webpack_public_path__ + "fonts/check-green.svg";